module.exports = {"noMoreShowButton":"Už nezobrazovať"}